import { render, staticRenderFns } from "./dialogSendForm.vue?vue&type=template&id=40ad1434&scoped=true&"
import script from "./dialogSendForm.vue?vue&type=script&lang=js&"
export * from "./dialogSendForm.vue?vue&type=script&lang=js&"
import style0 from "./dialogSendForm.vue?vue&type=style&index=0&id=40ad1434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad1434",
  null
  
)

export default component.exports